import { render, staticRenderFns } from "./ManualDownload.vue?vue&type=template&id=65203016&"
import script from "./ManualDownload.vue?vue&type=script&lang=js&"
export * from "./ManualDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports